<div class="row mb-3 align-items-center">
    <label class="col-md-8 col-form-label"> {{ model.q1descText }} </label>
    <div class="col-md-4">
        <pace-core-radio-input [(model)]="model.questionPSI1" [parentForm]="parentForm" (valueChange)="optionChange()">
        </pace-core-radio-input>
    </div>
</div>
<div class="row mb-3 align-items-center">
    <label class="col-md-8 col-form-label"> {{ model.q2descText }} </label>
    <div class="col-md-4">
        <pace-core-radio-input [(model)]="model.questionPSI2" [parentForm]="parentForm" (valueChange)="optionChange()">
        </pace-core-radio-input>
    </div>
</div>
<div class="row mb-3 align-items-center">
    <label class="col-md-8 col-form-label"> {{ model.q3descText }} </label>
    <div class="col-md-4">
        <pace-core-radio-input [(model)]="model.questionPSI3" [parentForm]="parentForm" (valueChange)="optionChange()">
        </pace-core-radio-input>
    </div>
</div>
<div class="row mb-3 align-items-center">
    <label class="col-md-8 col-form-label"> {{ model.q4descText }} </label>
    <div class="col-md-4">
        <pace-core-radio-input [(model)]="model.questionPPI4" [parentForm]="parentForm" (valueChange)="optionChange()">
        </pace-core-radio-input>
    </div>
</div>
@if (model.showCyberSecurityComplaintQuestion) {
    <div class="row mb-3 align-items-center">
        <label class="col-md-8 col-form-label"> {{ model.q5descText }} </label>
        <div class="col-md-4">
            <pace-core-radio-input
                [(model)]="model.questionCYS5"
                [parentForm]="parentForm"
                (valueChange)="optionChange()"
            >
            </pace-core-radio-input>
        </div>
    </div>
}
@if (model.complaintAlreadySubmitted) {
    <p class="fw-bold">Complaint already submitted, no further complaint creation possible.</p>
} @else {
    @if (model.showCommonQuestionnaire()) {
        <div class="row mb-3 align-items-center">
            <label class="col-md-6 col-form-label">Provide feedback to customer</label>
            <pace-core-radio-input
                [(model)]="model.qcaFields.feedback"
                [parentForm]="parentForm"
            ></pace-core-radio-input>
        </div>

        <h2>{{ model.ticketTitle }}</h2>

        <div class="row mb-3 align-items-center">
            <label class="col-md-6 col-form-label">What is the problem?</label>
            <pace-core-text-input [(model)]="model.qcaTexts.problem" [parentForm]="parentForm"></pace-core-text-input>
        </div>
        <div class="row mb-3 align-items-center">
            <label class="col-md-6 col-form-label">When does it occur?</label>
            <pace-core-text-input
                [(model)]="model.qcaTexts.occurrence"
                [parentForm]="parentForm"
            ></pace-core-text-input>
        </div>
        <div class="row mb-3 align-items-center">
            <label class="col-md-6 col-form-label">What has been done so far?</label>
            <pace-core-text-input
                [(model)]="model.qcaTexts.activities"
                [parentForm]="parentForm"
            ></pace-core-text-input>
        </div>
        <div class="row mb-3 align-items-center">
            <label class="col-md-6 col-form-label">Date of (first) event</label>
            <pace-core-date-input
                [(model)]="model.qcaFields.dateFirstEvent"
                [parentForm]="parentForm"
            ></pace-core-date-input>
            <label class="col-md-6 col-form-label">Date Healthineers notified</label>
            <pace-core-date-input
                [(model)]="model.qcaFields.dateNotified"
                [parentForm]="parentForm"
            ></pace-core-date-input>
        </div>
        <div class="row mb-3 align-items-center">
            <label class="col-md-6 col-form-label">Who initiated this issue?</label>
            <pace-core-radio-input
                [(model)]="model.qcaFields.initiatedBy"
                [parentForm]="parentForm"
                (valueChange)="updateInitiatedBy()"
            ></pace-core-radio-input>
        </div>
        <div class="row mb-3 align-items-center">
            <label class="col-md-6 col-form-label">Contact Person</label>
            <pace-core-text-input
                [(model)]="model.qcaCreationSet.name2"
                [parentForm]="parentForm"
            ></pace-core-text-input>
        </div>
        <div class="row mb-3 align-items-center">
            <label class="col-md-6 col-form-label">Email</label>
            <pace-core-text-input
                [(model)]="model.qcaCreationSet.email"
                [parentForm]="parentForm"
            ></pace-core-text-input>
        </div>
        <div class="row mb-3 align-items-center">
            <label class="col-md-6 col-form-label">Telephone</label>
            <pace-core-text-input
                [(model)]="model.qcaCreationSet.phone"
                [parentForm]="parentForm"
            ></pace-core-text-input>
        </div>
        <div class="row mb-3 align-items-center">
            <label class="col-md-6 col-form-label">Damage to property other than equipment involved?</label>
            <pace-core-radio-input
                [(model)]="model.qcaFields.damage"
                [parentForm]="parentForm"
                (valueChange)="clearDependentFields(model.qcaFields.damage, [model.qcaTexts.damage])"
            ></pace-core-radio-input>
        </div>
        @if (model.qcaFields.damage.getSelectedValue() === optionYes) {
            <div class="row mb-3 align-items-center">
                <label class="col-md-6 col-form-label">Description of damage</label>
                <pace-core-text-input
                    [(model)]="model.qcaTexts.damage"
                    [parentForm]="parentForm"
                ></pace-core-text-input>
            </div>
        }
        <div class="row mb-3 align-items-center">
            <label class="col-md-6 col-form-label">Were accessories other than recommended by Healthineers used?</label>
            <pace-core-radio-input
                [(model)]="model.qcaFields.acc"
                [parentForm]="parentForm"
                (valueChange)="clearDependentFields(model.qcaFields.acc, [model.qcaTexts.otherAccessories])"
            ></pace-core-radio-input>
        </div>
        @if (model.qcaFields.acc.getSelectedValue() === optionYes) {
            <div class="row mb-3 align-items-center">
                <label class="col-md-6 col-form-label">Description of accessories</label>
                <pace-core-text-input
                    [(model)]="model.qcaTexts.otherAccessories"
                    [parentForm]="parentForm"
                ></pace-core-text-input>
            </div>
        }
        <div class="row mb-3 align-items-center">
            <label class="col-md-6 col-form-label">Did the customer inform a regulatory authority?</label>
            <pace-core-radio-input
                [(model)]="model.qcaFields.reported"
                [parentForm]="parentForm"
            ></pace-core-radio-input>
        </div>

        @if (model.showInvivoQuestionnaire && model.showAdditionalQuestionnaire()) {
            <div class="row mb-3 align-items-center">
                <label class="col-md-6 col-form-label">Was anyone injured (even slightly)?</label>
                <pace-core-radio-input
                    [(model)]="model.qcaFields.injury"
                    [parentForm]="parentForm"
                    (valueChange)="
                        clearDependentFields(model.qcaFields.injury, [
                            model.qcaTexts.extentInjury,
                            model.qcaFields.identity,
                            model.qcaFields.ageSexWeightAvailable,
                            model.qcaFields.age,
                            model.qcaFields.gender,
                            model.qcaFields.weight,
                            model.qcaFields.medical,
                            model.qcaTexts.medicalIntervention,
                            model.qcaTexts.personel,
                        ])
                    "
                ></pace-core-radio-input>
            </div>
            @if (model.qcaFields.injury.getSelectedValue() === optionYes) {
                <div class="row mb-3 align-items-center">
                    <label class="col-md-6 col-form-label">Extent of injury</label>
                    <pace-core-text-input
                        [(model)]="model.qcaTexts.extentInjury"
                        [parentForm]="parentForm"
                    ></pace-core-text-input>
                </div>
                <div class="row mb-3 align-items-center">
                    <label class="col-md-6 col-form-label">Identity (Who was injured?)</label>
                    <pace-core-dropdown
                        [(model)]="model.qcaFields.identity"
                        [parentForm]="parentForm"
                    ></pace-core-dropdown>
                </div>
                <div class="row mb-3 align-items-center">
                    <label class="col-md-6 col-form-label">Age, sex, and weight available?</label>
                    <pace-core-checkbox-input
                        [(model)]="model.qcaFields.ageSexWeightAvailable"
                        [parentForm]="parentForm"
                        (valueChange)="
                            clearDependentFields(model.qcaFields.ageSexWeightAvailable.model, [
                                model.qcaFields.age,
                                model.qcaFields.gender,
                                model.qcaFields.weight,
                            ])
                        "
                    ></pace-core-checkbox-input>
                </div>
                @if (model.qcaFields.ageSexWeightAvailable.value) {
                    <div class="row mb-3 align-items-center">
                        <label class="col-md-6 col-form-label">Age</label>
                        <pace-core-number-input
                            [(model)]="model.qcaFields.age"
                            [parentForm]="parentForm"
                        ></pace-core-number-input>
                    </div>
                    <div class="row mb-3 align-items-center">
                        <label class="col-md-6 col-form-label">Sex</label>
                        <pace-core-radio-input
                            [(model)]="model.qcaFields.gender"
                            [parentForm]="parentForm"
                        ></pace-core-radio-input>
                    </div>
                    <div class="row mb-3 align-items-center">
                        <label class="col-md-6 col-form-label">Weight</label>
                        <pace-core-text-input
                            [(model)]="model.qcaFields.weight"
                            [parentForm]="parentForm"
                        ></pace-core-text-input>
                    </div>
                }
                <div class="row mb-3 align-items-center">
                    <label class="col-md-6 col-form-label">Did the injury necessitate medical intervention?</label>
                    <pace-core-radio-input
                        [(model)]="model.qcaFields.medical"
                        [parentForm]="parentForm"
                        (valueChange)="
                            clearDependentFields(model.qcaFields.medical, [
                                model.qcaTexts.medicalIntervention,
                                model.qcaTexts.personel,
                            ])
                        "
                    ></pace-core-radio-input>
                </div>
                @if (model.qcaFields.medical.getSelectedValue() === optionYes) {
                    <div class="row mb-3 align-items-center">
                        <label class="col-md-6 col-form-label">Description of medical intervention</label>
                        <pace-core-text-input
                            [(model)]="model.qcaTexts.medicalIntervention"
                            [parentForm]="parentForm"
                        ></pace-core-text-input>
                    </div>
                    <div class="row mb-3 align-items-center">
                        <label class="col-md-6 col-form-label">Who performed the medical intervention?</label>
                        <pace-core-text-input
                            [(model)]="model.qcaTexts.personel"
                            [parentForm]="parentForm"
                        ></pace-core-text-input>
                    </div>
                }
            }
            <div class="row mb-3 align-items-center">
                <label class="col-md-6 col-form-label">Accidental radiation occurrences (ARO)?</label>
                <pace-core-radio-input
                    [(model)]="model.qcaFields.accidentalRadiationOccurrences"
                    [parentForm]="parentForm"
                    (valueChange)="
                        clearDependentFields(model.qcaFields.accidentalRadiationOccurrences, [
                            model.qcaTexts.radiationDamage,
                        ])
                    "
                ></pace-core-radio-input>
            </div>
            @if (model.qcaFields.accidentalRadiationOccurrences.getSelectedValue() === optionYes) {
                <div class="row mb-3 align-items-center">
                    <label class="col-md-6 col-form-label">Description of accidental radiation occurrences</label>
                    <pace-core-text-input
                        [(model)]="model.qcaTexts.radiationDamage"
                        [parentForm]="parentForm"
                    ></pace-core-text-input>
                </div>
            }
            <div class="row mb-3 align-items-center">
                <label class="col-md-6 col-form-label"
                    >During the event: Was the device used to treat or diagnose patient?</label
                >
                <pace-core-radio-input
                    [(model)]="model.qcaFields.deviceUsed"
                    [parentForm]="parentForm"
                ></pace-core-radio-input>
            </div>
            <div class="row mb-3 align-items-center">
                <label class="col-md-6 col-form-label"
                    >During the event: Did the device fail to perform within specifications?</label
                >
                <pace-core-radio-input
                    [(model)]="model.qcaFields.actualFailure"
                    [parentForm]="parentForm"
                ></pace-core-radio-input>
            </div>
        }
        @if (model.showInvitroQuestionnaire && model.showAdditionalQuestionnaire()) {
            <div class="row mb-3 align-items-center">
                <label class="col-md-6 col-form-label">Occupation of person reporting the initial event</label>
                <pace-core-text-input
                    [(model)]="model.qcaTexts.occupant"
                    [parentForm]="parentForm"
                ></pace-core-text-input>
            </div>
            <div class="row mb-3 align-items-center">
                <label class="col-md-6 col-form-label">Description of primary event</label>
                <pace-core-dropdown
                    [(model)]="model.qcaFields.primaryEvent"
                    [parentForm]="parentForm"
                ></pace-core-dropdown>
            </div>
            <div class="row mb-3 align-items-center">
                <label class="col-md-6 col-form-label">Frequency of occurrence</label>
                <pace-core-text-input
                    [(model)]="model.qcaFields.frequency"
                    [parentForm]="parentForm"
                ></pace-core-text-input>
            </div>
            <div class="row mb-3 align-items-center">
                <label class="col-md-6 col-form-label">Who was affected?</label>
                <pace-core-dropdown [(model)]="model.qcaFields.identity" [parentForm]="parentForm"></pace-core-dropdown>
            </div>
            <div class="row mb-3 align-items-center">
                <label class="col-md-6 col-form-label">Age</label>
                <pace-core-number-input
                    [(model)]="model.qcaFields.age"
                    [parentForm]="parentForm"
                ></pace-core-number-input>
            </div>
            <div class="row mb-3 align-items-center">
                <label class="col-md-6 col-form-label">Sex</label>
                <pace-core-radio-input
                    [(model)]="model.qcaFields.gender"
                    [parentForm]="parentForm"
                ></pace-core-radio-input>
            </div>
            <div class="row mb-3 align-items-center">
                <label class="col-md-6 col-form-label">Patient/User Identifier (SIP/PID/ACCN)</label>
                <pace-core-text-input
                    [(model)]="model.qcaFields.safetyPerson"
                    [parentForm]="parentForm"
                ></pace-core-text-input>
            </div>
            <div class="row mb-3 align-items-center">
                <label class="col-md-6 col-form-label">Patient/User medication taken at time of event</label>
                <pace-core-text-input
                    [(model)]="model.qcaTexts.medications"
                    [parentForm]="parentForm"
                ></pace-core-text-input>
            </div>
            <div class="row mb-3 align-items-center">
                <label class="col-md-6 col-form-label"
                    >Did the patient/user have any pre-existing medical conditions?</label
                >
                <pace-core-radio-input
                    [(model)]="model.qcaFields.medical"
                    [parentForm]="parentForm"
                    (valueChange)="clearDependentFields(model.qcaFields.medical, [model.qcaTexts.medical])"
                ></pace-core-radio-input>
            </div>
            @if (model.qcaFields.medical.getSelectedValue() === optionYes) {
                <div class="row mb-3 align-items-center">
                    <label class="col-md-6 col-form-label">Please list all pre-existing medical conditions</label>
                    <pace-core-text-input
                        [(model)]="model.qcaTexts.medical"
                        [parentForm]="parentForm"
                    ></pace-core-text-input>
                </div>
            }
            <div class="row mb-3 align-items-center">
                <label class="col-md-6 col-form-label">Was the cause related to an instrument malfunction?</label>
                <pace-core-radio-input
                    [(model)]="model.qcaFields.malfunction"
                    [parentForm]="parentForm"
                ></pace-core-radio-input>
            </div>
            <div class="row mb-3 align-items-center">
                <label class="col-md-6 col-form-label"
                    >Was the cause related to a lack of required customer maintenance?</label
                >
                <pace-core-radio-input
                    [(model)]="model.qcaFields.maintenance"
                    [parentForm]="parentForm"
                ></pace-core-radio-input>
            </div>
            <div class="row mb-3 align-items-center">
                <label class="col-md-6 col-form-label"
                    >If patient results were affected, were the initial results reported to the physician?</label
                >
                <pace-core-radio-input
                    [(model)]="model.qcaFields.reportedMedical"
                    [parentForm]="parentForm"
                    (valueChange)="clearDependentFields(model.qcaFields.reportedMedical, [model.qcaFields.questioned])"
                ></pace-core-radio-input>
            </div>
            @if (model.qcaFields.reportedMedical.getSelectedValue() === optionYes) {
                <div class="row mb-3 align-items-center">
                    <label class="col-md-6 col-form-label">If reported, did the physician question the result?</label>
                    <pace-core-radio-input
                        [(model)]="model.qcaFields.questioned"
                        [parentForm]="parentForm"
                    ></pace-core-radio-input>
                </div>
            }
            <div class="row mb-3 align-items-center">
                <label class="col-md-6 col-form-label"
                    >Is it alleged that a medical procedure or treatment, that may later be unnecessary, was
                    performed?</label
                >
                <pace-core-radio-input
                    [(model)]="model.qcaFields.allegedMedical"
                    [parentForm]="parentForm"
                    (valueChange)="
                        clearDependentFields(model.qcaFields.allegedMedical, [model.qcaTexts.allegedTreatment])
                    "
                ></pace-core-radio-input>
            </div>
            @if (model.qcaFields.allegedMedical.getSelectedValue() === optionYes) {
                <div class="row mb-3 align-items-center">
                    <label class="col-md-6 col-form-label">What was the procedure or treatment? Be specific.</label>
                    <pace-core-text-input
                        [(model)]="model.qcaTexts.allegedTreatment"
                        [parentForm]="parentForm"
                    ></pace-core-text-input>
                </div>
            }
            <div class="row mb-3 align-items-center">
                <label class="col-md-6 col-form-label"
                    >Is it alleged that the test result caused a medical procedure, which may later be determined to
                    have been necessary, to have been delayed or withheld?</label
                >
                <pace-core-radio-input
                    [(model)]="model.qcaFields.actualFailure"
                    [parentForm]="parentForm"
                    (valueChange)="clearDependentFields(model.qcaFields.actualFailure, [model.qcaTexts.allegedTest])"
                ></pace-core-radio-input>
            </div>
            @if (model.qcaFields.actualFailure.getSelectedValue() === optionYes) {
                <div class="row mb-3 align-items-center">
                    <label class="col-md-6 col-form-label">Please describe the procedure</label>
                    <pace-core-text-input
                        [(model)]="model.qcaTexts.allegedTest"
                        [parentForm]="parentForm"
                    ></pace-core-text-input>
                </div>
            }
            <div class="row mb-3 align-items-center">
                <label class="col-md-6 col-form-label"
                    >Is it alleged that harm to the user or patient was caused by or related to use of the device
                    (regardless of whether the device is at fault or not)?</label
                >
                <pace-core-radio-input
                    [(model)]="model.qcaFields.deviceUsed"
                    [parentForm]="parentForm"
                    (valueChange)="clearDependentFields(model.qcaFields.deviceUsed, [model.qcaTexts.event])"
                ></pace-core-radio-input>
            </div>
            @if (model.qcaFields.deviceUsed.getSelectedValue() === optionYes) {
                <div class="row mb-3 align-items-center">
                    <label class="col-md-6 col-form-label">Please describe the event</label>
                    <pace-core-text-input
                        [(model)]="model.qcaTexts.event"
                        [parentForm]="parentForm"
                    ></pace-core-text-input>
                </div>
            }
            <div class="row mb-3 align-items-center">
                <label class="col-md-6 col-form-label">Was repeated testing performed to confirm the results?</label>
                <pace-core-radio-input
                    [(model)]="model.qcaFields.repeatTesting"
                    [parentForm]="parentForm"
                    (valueChange)="
                        clearDependentFields(model.qcaFields.repeatTesting, [
                            model.qcaFields.diffSample,
                            model.qcaFields.diffInstance,
                            model.qcaTexts.confidence,
                            model.qcaTexts.resultsRepeated,
                            model.qcaTexts.resultsUnit,
                            model.qcaFields.correctedReport,
                        ])
                    "
                ></pace-core-radio-input>
            </div>
            @if (model.qcaFields.repeatTesting.getSelectedValue() === optionYes) {
                <div class="row mb-3 align-items-center">
                    <label class="col-md-6 col-form-label">Was a different sample utilized for repeated testing?</label>
                    <pace-core-radio-input
                        [(model)]="model.qcaFields.diffSample"
                        [parentForm]="parentForm"
                    ></pace-core-radio-input>
                </div>
                <div class="row mb-3 align-items-center">
                    <label class="col-md-6 col-form-label"
                        >Was a different instrument utilized for the repeated testing?</label
                    >
                    <pace-core-radio-input
                        [(model)]="model.qcaFields.diffInstance"
                        [parentForm]="parentForm"
                        (valueChange)="clearDependentFields(model.qcaFields.diffInstance, [model.qcaTexts.instrument])"
                    ></pace-core-radio-input>
                </div>
                @if (model.qcaFields.diffInstance.getSelectedValue() === optionYes) {
                    <div class="row mb-3 align-items-center">
                        <label class="col-md-6 col-form-label"
                            >What instrument was used for the repeated testing?</label
                        >
                        <pace-core-text-input
                            [(model)]="model.qcaTexts.instrument"
                            [parentForm]="parentForm"
                        ></pace-core-text-input>
                    </div>
                }
                <div class="row mb-3 align-items-center">
                    <label class="col-md-6 col-form-label"
                        >What gave confidence that the repeated results were correct?</label
                    >
                    <pace-core-text-input
                        [(model)]="model.qcaTexts.confidence"
                        [parentForm]="parentForm"
                    ></pace-core-text-input>
                </div>
            }
            <div class="row mb-3 align-items-center">
                <label class="col-md-6 col-form-label">Were other clinical tests performed?</label>
                <pace-core-radio-input
                    [(model)]="model.qcaFields.otherTests"
                    [parentForm]="parentForm"
                    (valueChange)="clearDependentFields(model.qcaFields.otherTests, [model.qcaTexts.clinicalTests])"
                ></pace-core-radio-input>
            </div>
            @if (model.qcaFields.otherTests.getSelectedValue() === optionYes) {
                <div class="row mb-3 align-items-center">
                    <label class="col-md-6 col-form-label">List tests/results</label>
                    <pace-core-text-input
                        [(model)]="model.qcaTexts.clinicalTests"
                        [parentForm]="parentForm"
                    ></pace-core-text-input>
                </div>
            }
            <div class="row mb-3 align-items-center">
                <label class="col-md-6 col-form-label">Assay involved</label>
                <pace-core-text-input [(model)]="model.qcaTexts.assay" [parentForm]="parentForm"></pace-core-text-input>
            </div>
            <div class="row mb-3 align-items-center">
                <label class="col-md-6 col-form-label">Catalog No.</label>
                <pace-core-text-input
                    [(model)]="model.qcaTexts.catalogNr"
                    [parentForm]="parentForm"
                ></pace-core-text-input>
            </div>
            <div class="row mb-3 align-items-center">
                <label class="col-md-6 col-form-label">Lot Number</label>
                <pace-core-text-input [(model)]="model.qcaTexts.lotNr" [parentForm]="parentForm"></pace-core-text-input>
            </div>
            <div class="row mb-3 align-items-center">
                <label class="col-md-6 col-form-label">Expiration Date</label>
                <pace-core-date-input
                    [(model)]="model.qcaTexts.expireDate"
                    [parentForm]="parentForm"
                ></pace-core-date-input>
            </div>
            <div class="row mb-3 align-items-center">
                <label class="col-md-6 col-form-label">Initial result/Unit</label>
                <pace-core-text-input
                    [(model)]="model.qcaTexts.initialResult"
                    [parentForm]="parentForm"
                ></pace-core-text-input>
            </div>
            @if (model.qcaFields.repeatTesting.getSelectedValue() === optionYes) {
                <div class="row mb-3 align-items-center">
                    <label class="col-md-6 col-form-label">Repeated results/Units</label>
                    <pace-core-text-input
                        [(model)]="model.qcaTexts.resultsRepeated"
                        [parentForm]="parentForm"
                    ></pace-core-text-input>
                </div>
                <div class="row mb-3 align-items-center">
                    <label class="col-md-6 col-form-label">Result unit</label>
                    <pace-core-text-input
                        [(model)]="model.qcaTexts.resultsUnit"
                        [parentForm]="parentForm"
                    ></pace-core-text-input>
                </div>
                <div class="row mb-3 align-items-center">
                    <label class="col-md-6 col-form-label">Was a corrected report issued?</label>
                    <pace-core-radio-input
                        [(model)]="model.qcaFields.correctedReport"
                        [parentForm]="parentForm"
                    ></pace-core-radio-input>
                </div>
            }
        }
    }
}
